import * as React from 'react';
import styled from 'styled-components';
import {
  memoizedOnboardingSelectors,
  onboardingSelector,
} from '../../../../../../reducers/onboarding';
import { useSelector } from 'react-redux';
import onboardingUtils from '../../../../../../reducers/onboarding/utils';
import { ScannerFormValues } from '../../scanner/constants';
import { OBSensorConfigurations, Optional } from '../../../../../../types';

const Container = styled.div`
  width: 350px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #000000;
`;

export const Text = styled.div`
  font-size: 14px;
`;

const Divider = styled.div`
  height: 15px;
`;

type Props = {
  device: Optional<ScannerFormValues, 'vanilla'> & {
    packetConfig?: OBSensorConfigurations;
  };
  isInfoSet: boolean;
};

export const Summary: React.FunctionComponent<Props> = ({
  device,
  isInfoSet,
}) => {
  const { name, model, siteId } = device;

  const getSiteName = React.useMemo(
    () => onboardingSelector.getSiteByUuid(siteId),
    [siteId],
  );

  const availableHardware = useSelector(
    memoizedOnboardingSelectors.getAvailableHardware,
  );

  const siteName = useSelector(getSiteName) || { name: '' };

  return (
    <Container>
      {!isInfoSet && (
        <Text>
          Configure one of your included physical{' '}
          {device.packetConfig ? 'sensors' : 'scanners'}.
        </Text>
      )}
      {isInfoSet && (
        <>
          <div>
            <Title>
              {device.packetConfig ? 'Sensor Name' : 'Scanner Name'}
            </Title>
            <Text>{name}</Text>
            <Divider />
          </div>
          <div>
            <Title>Sensor Model</Title>
            <Text>
              {onboardingUtils.getHardwareInfoByHardwareKey(
                device.packetConfig
                  ? availableHardware.sensors
                  : availableHardware.scanners,
                model,
              )?.label ?? model}
            </Text>
            <Divider />
          </div>
          <div>
            {' '}
            <Title>Site</Title>
            <Text>{siteName.name}</Text>
          </div>
        </>
      )}
    </Container>
  );
};
